import classNames from "classnames";

export interface CheckmarkProps {
  isChecked: boolean;
}

export const Checkmark = ({ isChecked }: CheckmarkProps) => (
  <span
    className="absolute left-0 block h-8 w-full p-1.5"
    aria-checked={isChecked}
  >
    <span className="relative flex size-full items-center">
      <span
        aria-hidden="true"
        className={classNames(
          "pointer-events-none absolute inline-block size-5 rounded-full transition-[left] duration-200 ease-in-out",
          {
            "bg-v2-success left-[calc(100%-1.25rem)]": isChecked,
            "bg-dark left-0": !isChecked,
          },
        )}
      />
    </span>
  </span>
);
